import { Box, Stack, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useState } from 'react';
import { ReportsAnalyticsView } from './ReportsView';
import { KpiAlertsView } from './KpiAlertsView';
import { CustomReportsView } from './CustomReportsView';
import { NotaryDashboard } from './NotaryDashboard';

/**
 * Top-Level-Reports-View mit zwei Tabs:
 *  - „Auswertungen" (interaktive Reports + Diagramme)
 *  - „KPIs & Alerts" (Schwellenwerte + Mail-Benachrichtigung)
 */
export const ReportsHome: React.FC = () => {
  const [tab, setTab] = useState<
    'dashboard' | 'analytics' | 'alerts' | 'custom'
  >('dashboard');

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction='row' alignItems='center' spacing={1.5} sx={{ mb: 1 }}>
        <InsertChartIcon color='primary' fontSize='large' />
        <Box>
          <Typography variant='h5'>Reports</Typography>
          <Typography variant='caption' color='text.secondary'>
            Auswertungen, Diagramme und KPI-Überwachung für Ihr Notarbüro.
          </Typography>
        </Box>
      </Stack>

      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <TabList
            onChange={(_, v) =>
              setTab(v as 'dashboard' | 'analytics' | 'alerts' | 'custom')
            }
          >
            <Tab
              icon={<DashboardIcon fontSize='small' />}
              iconPosition='start'
              label='Dashboard'
              value='dashboard'
            />
            <Tab
              icon={<InsertChartIcon fontSize='small' />}
              iconPosition='start'
              label='Auswertungen'
              value='analytics'
            />
            <Tab
              icon={<NotificationsActiveIcon fontSize='small' />}
              iconPosition='start'
              label='KPIs & Alerts'
              value='alerts'
            />
            <Tab
              icon={<BuildIcon fontSize='small' />}
              iconPosition='start'
              label='Eigene Reports'
              value='custom'
            />
          </TabList>
        </Box>

        <TabPanel value='dashboard' sx={{ p: 0 }}>
          <NotaryDashboard />
        </TabPanel>
        <TabPanel value='analytics' sx={{ p: 0 }}>
          <ReportsAnalyticsView />
        </TabPanel>
        <TabPanel value='alerts' sx={{ p: 0 }}>
          <KpiAlertsView />
        </TabPanel>
        <TabPanel value='custom' sx={{ p: 0 }}>
          <CustomReportsView />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
